<template>
  <div class="content order-list list report-list">
    <div class="row">
      <div class="col-sm-12">
        <el-card>
          <h4 style="color: #3b291d">Contract List</h4>
          <!-- Start search part -->
          <div class="row">
            <div class="col-sm-5">
              <base-input label="Campaign Date Range" class="range-picker">
                <el-date-picker type="daterange" placeholder="Campaign Date Range" v-model="searchKey.campaignDate2"
                  value-format="YYYY-MM-DD" format="DD/MM/YYYY">
                </el-date-picker>
              </base-input>
            </div>

            <div class="col-sm-2">
              <base-input placeholder="" label="Salesman" :clearable="true">
                <el-select clearable v-model="searchKey.searchData.salesman" class="select-primary" size="large"
                  filterable style="width: 100%" placeholder="Salesman">
                  <el-option class="select-primary" v-for="item in SalesList" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </base-input>
            </div>

            <div class="col-sm-2">
              <base-input placeholder="" label="Site Name / Code" type="search">
                <el-input clearable style="
                    border: 1px solid hsl(0, 0%, 5%);
                    border-radius: 5px;
                    --el-input-focus-border-color: #f0f3f7;
                    margin-top: -2px;
                  " v-model="searchKey.siteNameCode">
                </el-input>
              </base-input>
            </div>
            <base-input label="Unit" :clearable="true">
              <el-select v-model="searchKey.searchData.unit" class="select-primary" filterable size="large"
                placeholder="Unit" disabled>
                <el-option label="All" value=""> </el-option>
                <el-option label="BB" value="BB"> </el-option>
              </el-select>
            </base-input>
          </div>
          <div class="row">
            <div class="col-sm-5">
              <base-input placeholder="" label="Contracting Party / Advertiser" style="margin-top: 4px"
                :clearable="true">
                <el-select clearable v-model="searchKey.contractPartOrAdvertiser" class="select-primary" size="large"
                  filterable style="width: 100%" placeholder="Contracting Party / Advertiser">
                  <el-option class="select-primary" v-for="item in AdvertiserOptionals" :key="item" :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </base-input>
            </div>
            <div class="col-sm-2">
              <base-input label="Contract No.">
                <el-input placeholder="Contract No." clearable style="
                    border: 1px solid hsl(0, 0%, 5%);
                    border-radius: 5px;
                    --el-input-focus-border-color: #f0f3f7;
                  " v-model="searchKey.searchData.contractNumber"></el-input>
              </base-input>
            </div>
            <div class="col-sm-2">
              <base-input label="Product / Category">
                <el-input placeholder="Product / Category" clearable style="
                    border: 1px solid hsl(0, 0%, 5%);
                    border-radius: 5px;
                    --el-input-focus-border-color: #f0f3f7;
                  " v-model="searchKey.searchData.product"></el-input>
              </base-input>
            </div>
            <div class="col-sm-3">
              <div style="column-gap: 5px; top: 30px"></div>
              <div class="row">
                <div style="
                    column-gap: 5px;
                    text-align: right;
                    position: absolute;
                    bottom: 5px;
                  ">
                  <base-button type="primary" @click="search" style="width: 100px">Search</base-button>
                  <base-button type="primary" @click="reset" style="width: 100px">Reset</base-button>
                  <base-button type="primary" @click="exportExcel"
                    v-if="useAuthority.GetAuthority('ContractList_ExportExcel')" style="width: 180px">Export
                    Excel</base-button>
                </div>
              </div>
            </div>
          </div>
          <!-- end Search part-->
          <div class="row" style="margin-top: 20px">
            <div class="col-sm-12" style="display: flex">
              <span style="
                  margin-left: auto;
                  line-height: 32px;
                  padding-right: 20px;
                ">
                Total No. of Record: {{ searchKey.total }}
                <base-pagination class="pagination-no-border" v-model="searchKey.pageIndex" :total="searchKey.total"
                  :pagesToDisplay="10" style="float: right" :value="searchKey.pageIndex" @changePage="ChangePageSearch"
                  @nextPage="ChangePageSearch">
                </base-pagination>
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <el-table :data="contractlist" style="width: 100%" border header-row-class-name="header-row"
                @filter-change="filterChange" table-layout="auto" cell-class-name="report-cell"
                @sort-change="sortChange" class="contract-list is-sort is-sort-sm is-filter">
                <el-table-column prop="unit" label="Unit" :width="70" />
                <el-table-column prop="contractType" label="Type" :width="140">
                  <template #header>
                    <div style="order: 1">Type</div>
                    <div class="search" style="order: 3">
                      <table-column-filter filterKey="contractType" v-model="searchKey.searchData.contractType"
                        @click="columnFilterClick" @close="activeFilterLabel = ''"
                        :visible="activeFilterLabel === 'contractType'" @confirm="search" virtual-triggering />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="contractNumber" label="Contract No." :width="180" sortable="custom"
                  :sort-orders="null">

                  <template #header>
                    <div style="order: 1">Contract No.</div>
                    <div class="search" style="order: 3">
                      <table-column-filter filterKey="contractNumber" v-model="searchKey.searchData.contractNumber"
                        @click="columnFilterClick" @close="activeFilterLabel = ''"
                        :visible="activeFilterLabel === 'contractNumber'" @confirm="search" virtual-triggering />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="contractingParty" label="Contracting Party" :width="230">

                  <template #header>
                    <div style="order: 1">Contracting Party</div>
                    <div class="search" style="order: 3">
                      <table-column-filter filterKey="contractingParty" v-model="searchKey.searchData.contractingParty"
                        @click="columnFilterClick" @close="activeFilterLabel = ''"
                        :visible="activeFilterLabel === 'contractingParty'" @confirm="search" virtual-triggering />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="advertiser" label="Advertiser" :width="230">

                  <template #header>
                    <div style="order: 1">Advertiser</div>
                    <div class="search" style="order: 3">
                      <table-column-filter filterKey="advertiser" v-model="searchKey.searchData.advertiser"
                        @click="columnFilterClick" @close="activeFilterLabel = ''"
                        :visible="activeFilterLabel === 'advertiser'" @confirm="search" virtual-triggering />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="product" label="Product" :width="0" min-width="150">

                  <template #header>
                    <div style="order: 1">Product</div>
                    <div class="search" style="order: 3">
                      <table-column-filter filterKey="product" v-model="searchKey.searchData.product"
                        @click="columnFilterClick" @close="activeFilterLabel = ''"
                        :visible="activeFilterLabel === 'product'" @confirm="search" virtual-triggering />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="campaignStart" label="Campaign Start" :formatter="formatterCellDate" width="180"
                  sortable="custom" :sort-orders="null">

                  <template #header>
                    <div style="order: 1">Campaign Start</div>
                    <div style="order: 3" class="search">
                      <table-column-filter filterKey="campaignStart2" @click="columnFilterClick" inputType="date"
                        @close="activeFilterLabel = ''" v-model="searchKey.campaignStart2"
                        :visible="activeFilterLabel === 'campaignStart2'" @confirm="search" virtual-triggering />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="campaignEnd" label="Campaign End" :formatter="formatterCellDate" width="180"
                  sortable="custom" :sort-orders="null">

                  <template #header>
                    <div style="order: 1">Campaign End</div>
                    <div style="order: 3" class="search">
                      <table-column-filter filterKey="campaignEnd2" @click="columnFilterClick" inputType="date"
                        @close="activeFilterLabel = ''" v-model="searchKey.campaignEnd2"
                        :visible="activeFilterLabel === 'campaignEnd2'" @confirm="search" virtual-triggering />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="contractTotalAmount" :formatter="formatterCellMoney" label="Contract Amount"
                  :width="130" />
                <el-table-column prop="salesman" label="Salesman" :width="140">

                  <template #header>
                    <div style="order: 1">Salesman</div>
                    <div class="search" style="order: 3">
                      <table-column-filter filterKey="salesman" v-model="searchKey.searchData.salesman"
                        @click="columnFilterClick" @close="activeFilterLabel = ''"
                        :visible="activeFilterLabel === 'salesman'" @confirm="search" virtual-triggering />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="createDate" label="Create Date" :formatter="formatterCellDateTime" :width="160"
                  sortable="custom" @sort-change="sortChange" :sort-orders="null" />
                <el-table-column prop="status" label="Status" :filters="typeList.ContractStatusTypeList"
                  filter-placement="bottom-end" :width="110" column-key="contractStatusTypes" />
                <el-table-column prop="signed" label="Signed" :filters="typeList.SignedTypeList"
                  filter-placement="bottom-end" :width="110" column-key="signedTypes" />

                <el-table-column prop="" fixed="right" label="Action" :width="80" class-name="action">

                  <template #default="scope">
                    <el-button type="text" @click="OpenBookingInfo(scope.row, 'ContractInfo')"><el-icon :size="18"
                        style="color: #303133">
                        <Search />
                      </el-icon></el-button>
                    <el-button type="text" v-if="scope.row.showRemarkIcon"
                      @click="OpenBookingInfo(scope.row, 'AdditionalInfo')"><el-icon :size="18" style="color: #303133">
                        <ChatLineSquare />
                      </el-icon></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div></div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script setup>
// import './css/index.css';
import { watch, ref, reactive, onBeforeMount, onMounted } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import basePagination from '@/components/newUI/BasePagination';
import tableColumnFilter from '@/components/tablecolumn/tableColumnFilter.vue';
import PubSub from 'pubsub-js';

import { useContractStore } from '@/store/contract';
import { useAuthorityStore } from '@/store/authority';
const useAuthority = useAuthorityStore();

// router
import router from '@/router';
import booknet from '@/network/booknet';

// api
import basicapi from '@/network/optional';

// icon
import { Edit, Search, ChatLineSquare } from '@element-plus/icons-vue';

// tool
import {
  formatterCellMoney,
  formatterCellDate,
  formatterCellDateTime,
} from '@/assets/js/formatter';

const useContract = useContractStore();

const typeList = reactive({
  SignedTypeList: [
    { text: 'Open', value: 'Open' },
    { text: 'Approving', value: 'Approving' },
    { text: 'Signed', value: 'Signed' },
  ],
  ContractStatusTypeList: [
    { text: 'Open', value: 'Open' },
    { text: 'Approving', value: 'Approving' },
    { text: 'Issued', value: 'Issued' },
    { text: 'Void', value: 'Void' },
    // { text: 'Revised', value: 'Revised' }
  ],
});
//const result = ref("");
//变更分页
const ChangePageSearch = async (data) => {
  searchKey.pageIndex = data;
  search();
};
//搜索条件实体
const searchKey = reactive({
  pageIndex: 1,
  pageSize: 10,
  searchData: { unit: 'BB' },
});
const activeFilterLabel = ref('');

const SalesList = ref([]);
const AdvertiserOptionals = ref([]);

// #region datas
const contractlist = ref([]);
// #endregion

onBeforeMount(async () => {
  // 读取基本的Option
  const optionals1 = await booknet.GetOrderSalesmanList().then((res) => res);
  // 销售员选项
  SalesList.value = optionals1.data;

  // ContractingParty
  var result = await booknet.GetOrderContractingPartyList().then((res) => res);
  AdvertiserOptionals.value = result.data;

  await search();
});

const OpenBookingInfo = async (item, tabName) => {
  useContract.activeName = tabName;

  // var ContractNo = item.contractNumberMedia;
  // if (!(ContractNo && ContractNo.length > 0)) {
  //   ContractNo = item.contractNumberProduction;
  // }

  window.open(
    `contract?ContractNo=${item.openContractNumber}&cId=${item.contract_Id}`
  );

  // router.push({
  //   name: 'contract',
  //   query: {
  //     ContractNo: item.openContractNumber,
  //     cId: item.contract_Id,
  //   },
  // });
};

// event: Search
const search = async () => {
  searchKey.isToExcel = false;
  const search_res = await booknet
    .GetReportContractList(searchKey)
    .then((res) => res);
  searchKey.total = search_res.data.total;
  contractlist.value = search_res.data.list;
};

const sortChange = async (column) => {
  searchKey.orderBy = column.order;
  searchKey.orderByColumn = column.prop;

  await search();
};
//重置筛选条件
const reset = async () => {
  //清空对象
  Object.keys(searchKey).map((key) => {
    delete searchKey[key];
  });
  searchKey.pageIndex = 1;
  searchKey.pageSize = 10;
  searchKey.searchData = { unit: 'BB' };
  search();
};
const filterChange = async (filters) => {
  if (filters.signedTypes) {
    searchKey.signedTypes = filters.signedTypes;
  }
  if (filters.contractStatusTypes) {
    searchKey.contractStatusTypes = filters.contractStatusTypes;
  }
  await search();
};
//导出数据到excel
const exportExcel = async () => {
  searchKey.isToExcel = true;
  const result = await booknet
    .GetReportContractList(searchKey)
    .then((res) => res);
  if (result.status === 200) {
    window.open(
      result.data.replace(
        'http://18.166.57.80:3012',
        'https://bb-matrix-api.asiaray.com'
      ),
      '_self'
    );
  }
};
//组件传值
onMounted(async () => {
  PubSub.subscribe('mode', (name, data) => {
    // 动态赋值
    searchKey[`${data.key}`] = data.value;
    search();
  });
});

const columnFilterClick = (key) => {
  activeFilterLabel.value = key;
};
</script>

<style scoped>
.orderlist {
  font-size: 13px;
}

.searchs {
  width: 1213px;
  display: flex;
  flex-wrap: wrap;
  padding: 5px 0;
}

.searchs-item {
  line-height: 2.1rem;
  display: flex;
}

.searchs-item .searchs-item-control {
  padding: 0 50px 0 10px;
}

.filter-cell {
  line-height: 2rem;
}

.filter-cell-title {
  padding: 5px 0;
}

.filter-cell-icon {
  position: absolute;
  top: 0;
  right: 12px;
}

.filter-cell-control {
  min-width: 230px;
}

.el-pagination {
  float: right;
}
</style>

<style>
.orderlist .report-cell .cell {
  word-break: break-word;
}

.contract-list table.el-table__body th .cell {
  display: flex;
  align-items: center;
  padding-top: 6px;
  padding-bottom: 6px;
}

.range-picker .el-date-editor {
  border: 0px !important;
}

.content.order-list .form-group.has-label .el-input__inner {
  position: relative;
  top: 5px;
}

.is-filter .search {
  flex-grow: 1;
  text-align: right;
}
</style>
